import React, { useState } from "react";
import { IslamicStar } from "./CategoryTiles";

const BAD = /flipkart\.com\/full-image-view|^https?:\/\/(www\.)?(flipkart\.com|amazon\.in|meesho\.com)\/?$/i;
const fullSrc = (s) => (s && s.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${s}` : s);

export const ProductImage = ({ src, alt, className = "", testid }) => {
  const [bad, setBad] = useState(false);
  if (!src || bad || BAD.test(src)) {
    return (
      <div className={`flex flex-col items-center justify-center bg-[#0B0F0D] ${className}`} data-testid={testid ? `${testid}-placeholder` : undefined}>
        <IslamicStar className="w-1/3 h-1/3 opacity-70" />
        <span className="mt-2 text-[10px] tracking-[0.2em] uppercase text-[#D4AF37]/80">Bengal Umrah House</span>
      </div>
    );
  }
  return (
    <div className={`bg-white flex items-center justify-center ${className}`}>
      <img src={fullSrc(src)} alt={alt} loading="lazy" referrerPolicy="no-referrer" onError={() => setBad(true)} data-testid={testid}
        className="w-full h-full object-contain p-2 transition-transform duration-500 group-hover:scale-105" />
    </div>
  );
};
